{
  "lifetools.sum": "Toplam",
  "lifetools.average": "Ortalama",
  "lifetools.ratio": "Oran",
  "lifetools.parameters": "Parametreler ve hedefler",
  "lifetools.metric_count_one": "1 gösterge",
  "lifetools.metric_count_other": "{{count}} gösterge",
  "lifetools.rule_count_one": "1 kural",
  "lifetools.rule_count_other": "{{count}} kural",
  "lifetools.inbox_count_one": "1 bildirim",
  "lifetools.inbox_count_other": "{{count}} bildirim",
  "lifetools.refresh": "Yenile",
  "lifetools.unknown_status": "Durum bilgisi yok",
  "lifetools.inbox_filters": "Bildirim filtreleri",
  "lifetools.inbox_select_all": "Görünen okunmamış bildirimleri seç",
  "lifetools.inbox_select_notification": "{{title}} bildirimini seç",
  "lifetools.inbox_selected_one": "1 bildirim seçildi",
  "lifetools.inbox_selected_other": "{{count}} bildirim seçildi",
  "lifetools.inbox_mark_selected_read": "Seçilenleri okundu işaretle",
  "lifetools.inbox_mark_notification_read": "{{title}} bildirimini okundu işaretle",
  "lifetools.inbox_bulk_read_error": "Seçilen bildirimler okundu olarak işaretlenemedi. Tekrar deneyin.",
  "lifetools.proactive_observations.title": "Sürekli gözlemler",
  "lifetools.proactive_observations.description": "Olgulara dayalı kontrollere katılın. Bir bulgu incelenebilir bir öneri oluşturur; işlerinizi asla otomatik olarak değiştirmez.",
  "lifetools.proactive_observations.load_error": "Sürekli gözlemler yüklenemedi",
  "lifetools.proactive_observations.action_error": "Bu gözlem güncellenemedi. Tekrar deneyin.",
  "lifetools.proactive_observations.unscheduled_commitment.title": "Planlanmamış taahhütler",
  "lifetools.proactive_observations.unscheduled_commitment.description": "Takvim bloğu olmayan açık görevleri bildirir.",
  "lifetools.proactive_observations.project_without_next_action.title": "Sonraki adımı olmayan projeler",
  "lifetools.proactive_observations.project_without_next_action.description": "Açıkça seçilmiş bir sonraki adım görevi olmayan etkin projeleri bildirir.",
  "lifetools.proactive_observations.routine_slipped_three_times.title": "Üç kez aksayan rutinler",
  "lifetools.proactive_observations.routine_slipped_three_times.description": "Son üç zamanı gelen tekrar açık veya atlanmış kaldığında bildirir.",
  "lifetools.proactive_observations.period_ending_with_open_work.title": "Açık işle biten dönemler",
  "lifetools.proactive_observations.period_ending_with_open_work.description": "Üye işler açıkken yedi gün içinde bitecek dönemleri bildirir.",
  "lifetools.proactive_observations.week_without_rest_block.title": "Dinlenme bloğu olmayan haftalar",
  "lifetools.proactive_observations.week_without_rest_block.description": "Etkin, korunan bir dinlenme aralığı olmayan takvim haftasını bildirir."
}
